import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { database } from './../firebase';
const publicUrl = process.env.PUBLIC_URL;
const rankOrder = {
  'ON': 1,
  'O6': 2,
  'O4': 3,
  'O2': 4,
  'OC': 5,
  'E9': 6,
  'E7': 7,
  'E5': 8,
  'E3': 9,
  'E1': 10
};

const Discordmods = ({ title, description }) => {
  const [staff, setStaff] = useState([]);
  const [marginRight, setMarginRight] = useState('4.5rem');

  useEffect(() => {
    const staffRef = database.ref('staffs');
  
    staffRef.on('value', (snapshot) => {
      const data = snapshot.val();
      const staffList = [];
  
      for (let id in data) {
        staffList.push({ id, ...data[id] });
      }
  
      // Sort staff based on rank
      const sortedStaffList = staffList.sort((a, b) => {
        const rankA = a.rank.split(' ')[0]; // Get the rank (e.g., E3 -> E, O6 -> O)
        const rankB = b.rank.split(' ')[0];
  
        return rankOrder[rankA] - rankOrder[rankB];
      });
  
      setStaff(sortedStaffList);
    });
  
    return () => {
      staffRef.off();
    };
  }, []);  

  return (
    <>
      <Helmet>
        <title>{title || 'Staffs - EnbyBase Official Website'}</title>
        <meta name="description" content={description || 'Staffs List of EnbyBase • TransBase'} />
        <meta property="og:title" content={title || 'Staffs - EnbyBase Official Website'} />
        <meta property="og:description" content={description || 'Staffs List of EnbyBase • TransBase'} />
      </Helmet>
      
      <div className="dsm-banner">
        <div className="dsm-banner-content">
          <div className="dsm-banner-text">
            Join our EnbyBase Alliance Staff Team! Be All You Can Be.
          </div>
          <button className="dsm-banner-btn">
            <a href="https://forms.gle/cDGMjmh8yVKyJWGw6" target="_blank" rel="noopener noreferrer">
              Join here
            </a>
          </button>
        </div>
      </div>

      <h1 className="dsm-title" style={{ paddingLeft: '25px'}}>EnbyBase Alliance Staff Directory</h1>

      {/* Grid Layout */}
      <div className='staff-grid-container'>
      <div className="staff-grid">
          {staff.map((member) => (
            <div key={member.id} className="staff-card">
<h3 style={{ zIndex: 99, color: '#333333' }}>{member.name}</h3>
              {/* Platform Icons */}
              <div className="platform-icons">
                {member.platforms.map((platform, index) => (
                  <span key={index} className="platform-icon">
                    {platform === 'EnbyBase Discord' && (
                      <img
                        className="platform-icon-img"
                        src={`${publicUrl}/favicon-512x512.jpg`}
                        alt="EnbyBase Discord Icon"
                      />
                    )}
                    {platform === 'TransBase Discord' && (
                      <img
                        className="platform-icon-img"
                        src={`${publicUrl}/android-chrome-512x512-tb.png`}
                        alt="TransBase Discord Icon"
                      />
                    )}
                    {platform === 'TransBase Subreddit' && (
                      <img
                        className="platform-icon-img"
                        src="https://firebasestorage.googleapis.com/v0/b/enbybase.appspot.com/o/cdn1%2Freddit-icon-512x512-mp8wosd1.png?alt=media&token=9800dafc-4168-4360-bf60-38825a5f1dc9"
                        alt="TransBase Subreddit Icon"
                      />
                    )}
                  </span>
                ))}
              </div>

              <p className="employee-role">{member.rank}</p>
              <p className="employee-role">{member.department}</p>
              <a className="employee-userid" href={member.link} target="_blank" rel="noopener noreferrer">Discord Profile</a>
            </div>
          ))}
        </div></div>

    </>
  );
};

export default Discordmods;
